module.exports = __webpack_public_path__ + "f351a084cee12d30fde6a8ddd60e96be.fbx";